// npm
import {
  atom,
} from 'recoil'

export const isSidebarOpenState = atom({
  key: 'isSidebarOpen',
  default: false,
})
